
/**
 * Formats a phone number to (XXX) XXX-XXXX format
 */
export const formatPhoneNumber = (phoneNumberString: string) => {
  // Strip all non-digits
  const cleaned = phoneNumberString.replace(/\D/g, '');
  
  // Limit to 10 digits
  const limited = cleaned.substring(0, 10);
  
  // Format
  const match = limited.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
  
  if (match) {
    const parts = [];
    if (match[1]) parts.push(`(${match[1]}`);
    if (match[2]) parts.push(`${match[2]}`);
    if (match[3]) parts.push(`${match[3]}`);
    
    return match[1] ? 
      `(${match[1]})${match[2] ? ` ${match[2]}` : ''}${match[3] ? `-${match[3]}` : ''}` : 
      limited;
  }
  
  return phoneNumberString;
};

/**
 * Normalizes a phone number to just digits
 */
export const normalizePhoneNumber = (phoneNumberString: string) => {
  return phoneNumberString.replace(/\D/g, '');
};
